export const INITIAL_LOAD = 1
export const SET_VARIABLES = 2
export const FETCH_MORE = 3
export const REFETCH = 4
export const POLL = 6
export const READY = 7
export const ERROR = 8
